import { Header } from '@/widgets'
import { Sidebar } from '@/widgets/sidebar/Sidebar'
import { resolveSubjectForPathname } from '@/shared/utils/resolvePathName'
import { refreshTokens } from '@/shared/api/client'
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected')({
  beforeLoad: async ({ context, location }) => {
    const { user, authStore, abilityStore } = context
    const abilities = abilityStore.abilities

    // An expired access token is not the end of the session — the refresh
    // token may still be valid, so try it before sending the user to login.
    const expirationTime = user?.exp ? user.exp * 1000 : 0
    if (Date.now() > expirationTime) {
      try {
        await refreshTokens()
      } catch {
        authStore.clearUser()
        return redirect({ to: '/auth/entry' })
      }
    }
    const subject = resolveSubjectForPathname(location.pathname)
    const hasAccess = subject !== null && abilities.can('read', subject)
    if (!hasAccess) return redirect({ to: '/forbidden' })
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div
      className="chakra-reset font-sans antialiased wrap-anywhere"
      style={{
        display: 'flex',
        width: '100%',
        minHeight: '100vh',
        // Transparent on purpose: the page wash is painted on <body> (see the
        // theme's globalCss) so the dark-mode gradient stays pinned to the viewport.
        background: 'transparent',
      }}
    >
      <Sidebar />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minWidth: 0,
          overflowX: 'hidden',
        }}
      >
        <Header />
        <div style={{ flex: 1 }}>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
